<div class="container">
    <form #mpiRequestForm role="form" class="form-horizontal text-left" action="{{ redirectUrl }}" method="POST" [formGroup]="cardRequestForm" (ngSubmit)="(onSubmit)">
        <!--        <div class="form-group row">-->
        <!--            <label for="request">Request Result</label><br>-->
        <!--            <textarea class="form-control" rows="3" cols="50" id="request">-->
        <!--              PAY_REQUEST_ID: {{payRequestId}}-->
        <!--              CHECKSUM: {{checksum}}-->
        <!--          </textarea>-->
        <!--        </div>-->
        <input type="hidden" name="PAYGATE_ID" formControlName="paygateId" />
        <input type="hidden" name="PAY_REQUEST_ID" formControlName="payRequestId" />
        <input type="hidden" name="CHECKSUM" formControlName="checksum" />
        <br />
        <div class="form-group row">
            <div class="col-sm-12 text-center">
                <a class="link-secondary text-center" type="submit">Verification required</a>
            </div>
        </div>
        <br />
    </form>
</div>
